import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-filtre-reporting-client',
  templateUrl: './filtre-reporting-client.component.html',
  styleUrls: ['./filtre-reporting-client.component.css']
})
export class FiltreReportingClientComponent implements OnInit {
  // Declaration Variable

  constructor() { }

  ngOnInit(): void {
  }

}
